import React from "react";

import { valuatorApi } from "@/main/api";
import { ValuatorSearchGridResponse } from "@/main/models/response";
import { ValuatorFilterRequest } from "@/main/models/request";
import { getTranslateByKey } from "@/main/services/utils";

import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import RowValuatorScreen from "./rowValuatorScreen/rowValuatorScreen";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";

import * as S from "./styles";

interface IGridValuatorProps {
	dataGrid: ValuatorSearchGridResponse[];
	formFilters: ValuatorFilterRequest | null;
	setDataGrid: React.Dispatch<React.SetStateAction<any[]>>;
}

function GridSearchValuator({ dataGrid, formFilters, setDataGrid }: IGridValuatorProps) {
	const rowHeaders = [
		getTranslateByKey("information.rfc"),
		getTranslateByKey("information.name"),
		`${getTranslateByKey("information.state")} / ${getTranslateByKey("information.city")}`,
		getTranslateByKey("information.status"),
	];

	async function fetchData(request: any) {
		return valuatorApi.getValuatorsGrid(request).then((response) => response.data);
	}

	return (
		<S.Container>
			<KOGPaginationGrid
				showTitleResults
				dataGrid={dataGrid}
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				fetchMore={fetchData}
			>
				<BoxGrid rowHeaders={rowHeaders}>
					{dataGrid.map((item, index) => (
						<RowValuatorScreen valuator={item} index={index} key={item.guid} />
					))}
				</BoxGrid>
			</KOGPaginationGrid>
		</S.Container>
	);
}

export default GridSearchValuator;
